export default {
  drawerIsMini: (state) => state.mini
}
